import { useEffect } from "react"

export default function FormBehaviors({
  id,
  queryType,
  searchPath,
  newAppIdentifierPath,
}) {
  useEffect(() => {
    const scope = `#${id}`

    $(`${scope} .modal`).on("shown.bs.modal", function () {
      $('input[type="text"]').focus()
    })

    $(`${scope} .modal input[type="text"]`).on("keydown", function (e) {
      return !(e && e.keyCode === 13)
    })

    $(document)
      .off(`click.delete-${id}`)
      .on(`click.delete-${id}`, `${scope} .delete-button`, function () {
        const $topDiv = $(this).parents().filter("tr")

        if ($topDiv.attr("data-id")) {
          let name = $topDiv
            .find('input[name*="_attributes]["][name$="[name]"]')
            .attr("name")
          name = name.replace("[name]", "[_destroy]")

          $topDiv.html(`<input type="hidden" name="${name}" value="true" />`)
        } else {
          $topDiv.html("")
        }
      })

    let timerId
    const appSearchInput = $(`${scope} input#app-search`)
    const changeHandler = function () {
      const value = appSearchInput.val()
      if (appSearchInput.data("lastval") !== value) {
        appSearchInput.data("lastval", value)

        clearTimeout(timerId)
        timerId = setTimeout(function () {
          $(`${scope} .add-app-modal table tbody`).html("")
          $(`${scope} .spinner-container`).css("display", "block")
          const bundleIds = $(`${scope} input[name*="identifier"]`)
            .map(function () {
              return $(this).val()
            })
            .toArray()

          $.ajax({
            url: searchPath,
            method: "POST",
            data: {
              id,
              term: value,
              existing_ids: bundleIds,
              country_code: $("select#country").val(),
              query_type: queryType,
            },
            dataType: "script",
          })
        }, 500)
      }
    }
    appSearchInput.on("input", changeHandler)
    $("select#country").on("change", function () {
      appSearchInput.data("lastval", null)
      changeHandler()
    })

    $(document)
      .off(`click.ranew-${id}`)
      .on(`click.ranew-${id}`, `${scope} .modal .add-app`, function () {
        function nextIndex() {
          const indexes = $(`${scope} .current-apps input[id*=_attributes_]`)
            .map(function () {
              return parseInt($(this).attr("id").match(/attributes_([\d]+)_/)[1])
            })

          let highestIndex = 0
          if (indexes.length > 0) {
            highestIndex = Math.max.apply(Math, indexes)
          }

          return highestIndex + 1
        }

        $(this).addClass("disabled").text("added")
        $.ajax({
          url: newAppIdentifierPath,
          data: {
            id,
            index: nextIndex(),
            identifier: $(this).attr("data-bundle-id"),
            name: $(this).attr("data-name"),
            query_type: queryType,
          },
          dataType: "script",
        })
      })

    return () => {
      $(document).off(`click.delete-${id}`)
      $(document).off(`click.ranew-${id}`)
      appSearchInput.off("input", changeHandler)
    }
  }, [id, queryType, searchPath, newAppIdentifierPath])

  return null
}
